import axios from 'axios';
const token = localStorage.getItem('Authorization');

const headers = {
    'Content-type': 'application/json',
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    'Accept-Language': 'es',
    Expires: '0',
    Pragma: 'no-cache',
    Authorization: `${token}`
};

export default axios.create({
    withCredentials: true,
    baseURL: import.meta.env.REACT_APP_HOME_API_URL,
    responseType: 'json',
    headers
});
